import { Controller } from "@hotwired/stimulus"

// Coffee Ratio Calculator (Phase 1 item 1.6).
//
// All brew-method data lives on the chip elements as data-*. JS just
// reads the selected chip + cups input, computes coffee/water grams,
// and renders the result panel. No backend.
export default class extends Controller {
  static targets = [
    "methodChip", "methodHint",
    "cups",
    "result", "resultTitle", "resultTagline",
    "coffeeAmount", "waterAmount",
    "ratioLabel", "waterTemp", "brewTime", "grind",
    "steps"
  ]

  selectMethod(event) {
    const chip = event.currentTarget
    this.methodChipTargets.forEach(c => { c.dataset.selected = "false" })
    chip.dataset.selected = "true"
    this._render()
  }

  onChange() {
    this._render()
  }

  increment() {
    this.cupsTarget.value = Math.min(parseInt(this.cupsTarget.value, 10) + 1, 12)
    this._render()
  }

  decrement() {
    this.cupsTarget.value = Math.max(parseInt(this.cupsTarget.value, 10) - 1, 1)
    this._render()
  }

  // ---- internals ----

  _selectedChip() {
    return this.methodChipTargets.find(c => c.dataset.selected === "true") || null
  }

  _render() {
    const chip = this._selectedChip()
    if (!chip) {
      this.resultTarget.classList.add("hidden")
      return
    }

    const cups = Math.max(parseInt(this.cupsTarget.value, 10) || 1, 1)
    const coffeePerCup = parseFloat(chip.dataset.coffeePerCup)
    const waterRatio = parseFloat(chip.dataset.waterRatio)

    const coffeeG = Math.round(coffeePerCup * cups)
    const waterG = Math.round(coffeeG * waterRatio)

    this.resultTitleTarget.textContent = `${cups} ${cups === 1 ? "cup" : "cups"} of ${chip.dataset.name}`
    this.resultTaglineTarget.textContent = chip.dataset.tagline || ""
    this.coffeeAmountTarget.textContent = coffeeG.toString()
    this.waterAmountTarget.textContent = waterG.toString()
    this.ratioLabelTarget.textContent = chip.dataset.ratioLabel
    this.waterTempTarget.textContent = chip.dataset.waterTemp ? `${chip.dataset.waterTemp}°C` : "—"
    this.brewTimeTarget.textContent = chip.dataset.brewTime
    this.grindTarget.textContent = chip.dataset.grind

    let steps = []
    try {
      steps = JSON.parse(chip.dataset.steps || "[]")
    } catch (_e) {
      steps = []
    }
    this.stepsTarget.innerHTML = steps.map(s => `<li>${this._escape(s)}</li>`).join("")

    this.methodHintTarget.textContent = `Recipe scaled for ${cups} ${cups === 1 ? "cup" : "cups"}.`
    this.resultTarget.classList.remove("hidden")
  }

  _escape(s) {
    const div = document.createElement("div")
    div.textContent = s
    return div.innerHTML
  }
}
